export enum TuffexProductCatalogueWorkspaceCapabilityUdoTemplateKey {
    productApiLog = "99c1678f-6b98-434c-84e4-d5832add8377",
    tag = "c883276b-327b-49e1-8043-f854fd6e6dbd",
    variantAttribute = "8a58de69-3fec-422f-ac5c-c1d19866a30a",
}
